import { render } from "./BidDetails.vue?vue&type=template&id=79bd907b&scoped=true"
import script from "./BidDetails.vue?vue&type=script&lang=js"
export * from "./BidDetails.vue?vue&type=script&lang=js"

import "./BidDetails.vue?vue&type=style&index=0&id=79bd907b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79bd907b"]])

export default __exports__